export default {"src":"/_next/static/media/towel-warmer.6095f933.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};